import { IonCheckbox, IonLabel, IonText, CheckboxChangeEventDetail, IonItem } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IServicesModalProps } from './services-modal-props.interface'
import './services-modal.scss'
import { useSelectableList } from 'hooks'
import { IPaidService } from 'interfaces'
import { BaseButton, BaseModal } from 'components'
import { IonCheckboxCustomEvent } from '@ionic/core'

const ServicesModal: React.FC<IServicesModalProps> = ({ services, selectedServices, isOpen, setIsOpen, onConfirmServices }) => {
  const [tmpSelectedServices, onTmpSelectedServices, setTmpSelectedServices] = useSelectableList<IPaidService>()
  const { t } = useTranslation()

  function dismiss() {
    setIsOpen(false)
    setTmpSelectedServices(selectedServices)
  }

  function clickConfirm() {
    onConfirmServices(tmpSelectedServices)
    setIsOpen(false)
  }

  function onCheckboxChange(e: IonCheckboxCustomEvent<CheckboxChangeEventDetail<any>>) {
    const service = services.find((s) => s.id === e.detail.value)
    if (service) onTmpSelectedServices(service, e.detail.checked)
  }

  const footer = <BaseButton label={t('update_total')} onClickFunction={() => clickConfirm()} />

  return (
    <BaseModal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      title={t('add_service')}
      footer={footer}
      dismiss={dismiss}
      className="edisu-services-modal"
    >
      {services.map((s) => {
        return (
          <div key={s.id} className="service-line">
            <IonItem className="edisu-checkbox" lines="none">
              <IonCheckbox
                slot="start"
                onIonChange={(e) => onCheckboxChange(e)}
                value={s.id}
                checked={tmpSelectedServices.findIndex((ss) => ss.id === s.id) !== -1}
              />
              <IonLabel>{s.descrizione}</IonLabel>
            </IonItem>
            <IonText className="edisu-price">{s.prezzo} €</IonText>
          </div>
        )
      })}
    </BaseModal>
  )
}

export default ServicesModal
